
export default {
    getName: (state) => state.name,
    getNextSeqCode: (state) => state.nextSeqCode,

    getConfigurations: (state) => state.configurations || [],
}